import styled from 'styled-components';
import Colors from '@/constants/Colors';

export const StyledSelectCreateOrLoginStep = styled.div`
  height: 100%;
  .options {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 30px;
    margin-top: 40px;

    .enroll-option {
      background-color: ${Colors.backgroundPaleBlueDark};
      padding: 20px;
      border-radius: 6px;

      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 300px;
      .option-description {
        margin-bottom: 0;
      }
    }
  }
`;
